import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, Button, Row, Col, Alert } from 'reactstrap';

const LoadingScreenModal = ({ isOpen, toggle, editingScreen, formData, setFormData, onSubmit }) => {
  const [previewUrl, setPreviewUrl] = useState(editingScreen?.url || null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validate file type
      if (!file.type.startsWith('image/')) {
        alert('Vui lòng chọn file hình ảnh');
        return;
      }

      // Validate file size (max 5MB)
      if (file.size > 5 * 1024 * 1024) {
        alert('File size không được vượt quá 5MB');
        return;
      }

      // Update form data
      setFormData({
        ...formData,
        file: file,
        filename: file.name,
        mimetype: file.type,
        size: file.size
      });

      // Create preview
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewUrl(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>
        {editingScreen ? 'Chỉnh sửa Loading Screen' : 'Tạo Loading Screen Mới'}
      </ModalHeader>
      <Form onSubmit={onSubmit}>
        <ModalBody>
          <Row>
            {/* File Upload */}
            {!editingScreen && (
              <Col md="12">
                <FormGroup>
                  <Label>Upload Image *</Label>
                  <Input
                    type="file"
                    accept="image/*"
                    onChange={handleFileChange}
                    required={!editingScreen}
                  />
                  <small className="text-muted">Max size: 5MB. Formats: JPG, PNG, GIF, WebP</small>
                </FormGroup>
              </Col>
            )}

            {/* Preview */}
            {previewUrl && (
              <Col md="12">
                <FormGroup>
                  <Label>Preview</Label>
                  <div className="border rounded p-2">
                    <img 
                      src={previewUrl} 
                      alt="Preview" 
                      className="img-fluid rounded"
                      style={{maxHeight: '300px', width: '100%', objectFit: 'contain'}}
                    />
                  </div>
                </FormGroup>
              </Col>
            )}

            <Col md="12">
              <FormGroup>
                <Label>Filename</Label>
                <Input
                  type="text"
                  value={formData.filename}
                  onChange={(e) => setFormData({...formData, filename: e.target.value})}
                  placeholder="loading-screen.jpg"
                  readOnly={!!formData.file}
                />
              </FormGroup>
            </Col>

            <Col md="6">
              <FormGroup>
                <Label>Display Time (ms) *</Label>
                <Input
                  type="number"
                  value={formData.time}
                  onChange={(e) => setFormData({...formData, time: parseInt(e.target.value)})}
                  placeholder="5000"
                  min="1000"
                  step="500"
                  required
                />
                <small className="text-muted">
                  {formData.time ? `${(formData.time / 1000).toFixed(1)} giây` : 'Thời gian hiển thị'}
                </small>
              </FormGroup>
            </Col>

            <Col md="6">
              <FormGroup>
                <Label className="d-block">Status</Label>
                <div className="form-check form-switch mt-2">
                  <Input
                    type="checkbox"
                    className="form-check-input"
                    checked={formData.isActive}
                    onChange={(e) => setFormData({...formData, isActive: e.target.checked})}
                  />
                  <Label className="form-check-label">
                    {formData.isActive ? 'Active' : 'Inactive'}
                  </Label>
                </div>
              </FormGroup>
            </Col>

            {/* File Info (read-only) */}
            {formData.file && (
              <Col md="12">
                <Alert color="info" className="mb-0">
                  <strong>File Info:</strong>
                  <ul className="mb-0 mt-1">
                    <li>Name: {formData.file.name}</li>
                    <li>Type: {formData.mimetype}</li>
                    <li>Size: {(formData.size / 1024).toFixed(2)} KB</li>
                  </ul>
                </Alert>
              </Col>
            )}
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>
            Hủy
          </Button>
          <Button color="primary" type="submit">
            <i className="fa fa-save me-2"></i>
            {editingScreen ? 'Cập nhật' : 'Tạo mới'}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default LoadingScreenModal;

